import React, { useState, useEffect } from 'react'

const JobApplication = () => {

    const [careerApplication, setCareerApplication] = useState([]);
    const [loading, setLoading] = useState(true);


    const fetchCareer = async () => {
        try {
            const response = await fetch('https://apis.anvifoundation.com/anvi/get-career');
            console.log(response);
            if (!response.ok) {
                throw new Error('Failed to fetch jobs');
            }
            const data = await response.json();
            setCareerApplication(data.career);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCareer();
    })

    return (
        <>
            <section className='my-5'>
                <div className='container'>

                    <p className='sec-heading'>Job Applications</p>
                    <hr className='sec-heading-hr my-0' />

                    <div className='table-responsive mt-5'>
                        <table className='jobApplication-table'>
                            <tr>
                                <th>Application No</th>
                                <th>Name</th>
                                <th>Position</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Education</th>
                                <th>Experience</th>
                                <th>Description</th>
                            </tr>

                            {loading ? (
                                <p>Loading Applications...</p>
                            ) : (
                                careerApplication.map((careerData, index) => (
                                    <tr key={index}>
                                        <td>{careerData.id}</td>
                                        <td>{careerData.name}</td>
                                        <td>{careerData.position}</td>
                                        <td>{careerData.email}</td>
                                        <td>{careerData.phone}</td>
                                        <td>{careerData.education}</td>
                                        <td>{careerData.experience}</td>
                                        <td>{careerData.description}</td>
                                    </tr>
                                ))
                            )}
                        </table>
                    </div>


                </div>
            </section>
        </>
    )
}

export default JobApplication
